import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ResponseService } from '../types/type';
import { catchError, retry, throwError, zip } from 'rxjs';
import { Utilerias } from '../helpers/Utilerias';
import { BajaUsuarioDTO, CatRegionesDTO, RegionesEstacionesDTO, RelacionUsuarioDTO, UsuarioDTO, UsuarioNombreIdEmpleadoDTO } from '../types/Entitys';
import { EstacionesTVADB } from '../DAO/EstacionesTVADB';
import { MasterDB } from '../DAO/MasterDB';

enum methods {
  GetUsuarios = 'GetUsuarios',
  SetUsuario = 'SetUsuario',
  UpdateUsuario = 'UpdateUsuario',
  DeleteUsuario = 'DeleteUsuario',
  GetCatalogoRoles = 'GetCatalogoRoles',
  GetCatalogoRegiones = 'GetCatalogoRegiones',
  GetNogocio = 'GetNogocio',
  GetEstaciones = 'GetEstaciones',
  GetRelacionUsuarioRegionEstacion = 'GetRelacionUsuarioRegionEstacion',
  AgregarRelacionUsuarioRegionEstacion = 'AgregarRelacionUsuarioRegionEstacion',
  PostBajaUsuario = 'PostBajaUsuario',
  ValidaRegistroUsuario = 'ValidaRegistroUsuario',
  GetUsuariosByIdNombreEmpleado = 'GetUsuariosByIdNombreEmpleado',
}

@Injectable({
  providedIn: 'root'
})
export class UsuariosService {
  headers: HttpHeaders;
  URL: string

  constructor(private http: HttpClient) {
    this.URL = environment.urlService
    this.headers = new HttpHeaders();
    if (localStorage?.jwt) {
      this.headers = new HttpHeaders({
        'Authorization': localStorage.jwt
      })
    }
  }

  async getUsuario() {
    return await MasterDB.getUsuarioSesion(new EstacionesTVADB())
  }

  getUsuariosByIdNombreEmpleado(body: UsuarioNombreIdEmpleadoDTO) {
    return this.http.post<ResponseService>(`${this.URL}${methods.GetUsuariosByIdNombreEmpleado}`, body, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  getUsuarios({ idEmpleado, page = 1 }: { idEmpleado: number, page?: number }) {
    return this.http.get<ResponseService>(`${this.URL}${methods.GetUsuarios}?idEmpleado=${idEmpleado}&page=${page}`, {
      headers: this.headers
    })
      .pipe(
        retry(3),
        catchError(this.handleError)
      )
  }

  getCatalogoRoles() {
    return this.http.get<ResponseService>(`${this.URL}${methods.GetCatalogoRoles}`, {
      headers: this.headers
    })
      .pipe(
        retry(3),
        catchError(this.handleError)
      )
  }

  getCatalogoRegiones(negocioId: CatRegionesDTO) {
    return this.http.post<ResponseService>(`${this.URL}${methods.GetCatalogoRegiones}`, negocioId, {
      headers: this.headers
    })
      .pipe(
        retry(3),
        catchError(this.handleError)
      )
  }

  fetchLoadInit(idEmpleado: number) {
    return zip(
      this.getUsuarios({ idEmpleado }),
      this.getNegocios(),
      this.getCatalogoRoles(),
    )
      .pipe(
        retry(3),
        catchError(this.handleError)
      )
  }

  getNegocios() {
    return this.http.get<ResponseService>(`${this.URL}${methods.GetNogocio}`, {
      headers: this.headers
    })
      .pipe(
        retry(3),
        catchError(this.handleError)
      )
  }

  getEstaciones(IdRegion: number) {
    return this.http.get<ResponseService>(`${this.URL}${methods.GetEstaciones}?idRegion=${IdRegion}`, {
      headers: this.headers
    })
      .pipe(
        retry(3),
        catchError(this.handleError)
      )
  }

  getRelacionUsuario(IdEmpleado: number) {
    return this.http.post<ResponseService>(`${this.URL}${methods.GetRelacionUsuarioRegionEstacion}`, { IdEmpleado },
      {
        headers: this.headers
      })
      .pipe(
        retry(3),
        catchError(this.handleError)
      )
  }

  postRelacionUsuarioRegionEstacion(usuario: RelacionUsuarioDTO) {
    return this.http.post<ResponseService>(`${this.URL}${methods.AgregarRelacionUsuarioRegionEstacion}`, usuario, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  fetchRegionesEstaciones(ids: RegionesEstacionesDTO) {
    return zip(
      this.getCatalogoRegiones({ Negocio_Id: ids.IdNegocio }),
      this.getEstaciones(ids.IdRegion)
    ).pipe(
      catchError(this.handleError)
    )
  }

  postBajaUsuario(idsEmpleado: BajaUsuarioDTO) {
    return this.http.post<ResponseService>(`${this.URL}${methods.PostBajaUsuario}`, idsEmpleado, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  validarUsuario(usuario: UsuarioDTO) {
    return this.http.post<ResponseService>(`${this.URL}${methods.ValidaRegistroUsuario}`, usuario, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  private handleError(error: HttpErrorResponse) {
    console.log('Error en Usuarios Service' + error.message);
    Utilerias.alertClient('Error al hacer la petición', 'Intente de nuevo', 1);
    if (error.status === HttpStatusCode.Unauthorized) {
      Utilerias.closeSesion(this.http);
      return throwError(() => new Error('!Error Unauthorized, verifique sus credenciales!'))
    }
    return throwError(() => new Error('!Fuera de servicio, intente nuevamente!'))
  }
}
